import { useTenantData } from 'providers/Tenant/TenantDataProvider';
import { MANTENCION_DEFAULTS } from 'assets/tenantConfigCatalog';

// Lee tenant.config.mantencion fusionado sobre los defaults del catálogo.
// Independiente de useTenantFlags (que es capa 1 / seguridad).
export const useMantencionConfig = () => {
  // useTenantData() devuelve null si no hay TenantDataProvider ancestro
  // (default del context). Fallback a {} para no crashear y caer en los
  // defaults del catálogo (mismo comportamiento que "tenant sin config").
  const { tenant } = useTenantData() || {};
  const raw = tenant?.config?.mantencion ?? {};
  const merged = { ...MANTENCION_DEFAULTS };
  for (const k of Object.keys(MANTENCION_DEFAULTS)) {
    if (typeof raw[k] === 'boolean') merged[k] = raw[k];
  }
  return {
    severidad: merged.hallazgo_severidad,
    severidadObligatoria: merged.severidad_obligatoria,
    sugerencias: merged.hallazgo_sugerencias,
    fotos: merged.hallazgo_fotos,
    aiRedaccion: merged.ai_redaccion,
  };
};

export default useMantencionConfig;
